export const FETCH_ALLEXPENSETYPE_REQUEST = 'FETCH_ALLEXPENSETYPE_REQUEST'
export const FETCH_ALLEXPENSETYPE_SUCCESS = 'FETCH_ALLEXPENSETYPE_SUCCESS'
export const FETCH_ALLEXPENSETYPE_FALIURE = 'FETCH_ALLEXPENSETYPE_FALIURE'
